import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import { ToastrService } from 'ngx-toastr';
import { UtilService } from 'src/app/shared/architecture/services/util.service';
import { ConfirmComponent } from 'src/app/shared/modal/confirm/confirm.component';
import { Dealer } from 'src/app/shared/models/dealer.model';
import { FrontOffice } from 'src/app/shared/models/front-office.model';
import { DealerService } from 'src/app/shared/services/core/dealer.service';
import { FrontOfficesService } from 'src/app/shared/services/core/front-offices.service';

@Component({
  selector: 'app-dealers-fof',
  imports: [TegelModule, CommonModule],
  templateUrl: './dealers-fof.component.html',
  styleUrl: './dealers-fof.component.scss'
})
export class DealersFofComponent implements OnInit {
  dealers: Dealer[];
  row: Dealer;
  fofs!: FrontOffice[];
  pageDealer = 1;
  pageFof = 1;
  searchtext = '';
  order = "id";
  singleclick = false;

  constructor(private utilService: UtilService,
              private dialogService: DialogService,
              private dealerService: DealerService,
              private frontOfficesService: FrontOfficesService,
              private toastr: ToastrService
  ) {
    this.dealers = [];
    this.row = new Dealer();
  }

  ngOnInit(): void {
    this.getAllDealers();
  }

  getAllDealers(){
    this.dealerService.get().subscribe((result) => {
      if (result) {
        this.dealers = result;
      }
    });
  }

  getFof(dealerCod: string) {
    this.singleclick = true;
    setTimeout(() => {
      if (this.singleclick) {
        this.frontOfficesService.getByDealer(dealerCod).subscribe((result) => {
          if (result) {
            this.fofs = result;
          }
        });
      }
    }, 250);
  }

  deleteFof(dealerCod: any, userSSB: any) {
    this.dialogService.addDialog(ConfirmComponent, {
      title: 'Confirmar',
      message: 'Deseja excluir o usuário ' + userSSB + ' ?'
    }, this.utilService.getModalOptions()).subscribe((resultConfirm) => {
      if (resultConfirm.confirmed) {
        this.frontOfficesService.delete(dealerCod, userSSB).subscribe((result) => {
          if (result && !result.hasErrors) { 
            let index = 0;
            do {
              index = this.fofs.findIndex(c => c.dealerCod === dealerCod && c.userSSB === userSSB);
              if (index > -1) {
                this.fofs.splice(index, 1);
              }
            } while (index != -1);

            this.toastr.success('Registro excluído.', 'Sucesso');
          }
        });
      }
    });
  }

  openEmailDealer(dealer: Dealer){
    this.singleclick = false;

    this.getFof(dealer.id.toString());
    // this.dialogService.addDialog(SaveEmailDealerComponent, {
    //   dealer: dealer
    // }, this.utilService.getModalOptions());
  }

  openSaveFof(operation: String, frontOffice = new FrontOffice()){
    frontOffice.dealerCod = this.row.id;

    // this.dialogService.addDialog(SaveFrontofficeDealerComponent, {
    //   fof: frontOffice,
    //   operation: operation
    // }, this.utilService.getModalOptions()).subscribe((result) => {
    //   if (result && result.success) {
    //     this.getFof(this.row.id.toString());
    //     this.toastr.success('Registro salvo.', 'Sucesso');
    //   }
    // });
  }

  selectedDealer(dealer: Dealer) {
    this.row = dealer;
    this.getFof(dealer.id.toString());
  }

}
